// Botón CTA — devuelve un <button> ya conectado a un click handler.
//
// Uso:
//   const btn = ctaButton({ label: 'Continuar', onClick: ..., variant: 'primary' });
//   container.appendChild(btn);

export function ctaButton({
  label,
  onClick,
  variant = 'primary',
  disabled = false,
  block = false,
  type = 'button',
  ariaLabel,
}) {
  const btn = document.createElement('button');
  btn.type = type;
  btn.className = `btn btn--${variant}${block ? ' btn--block' : ''}`;
  btn.textContent = label;
  if (ariaLabel) btn.setAttribute('aria-label', ariaLabel);
  if (disabled) {
    btn.disabled = true;
    btn.setAttribute('aria-disabled', 'true');
  }
  if (typeof onClick === 'function') {
    btn.addEventListener('click', onClick);
  }
  return btn;
}

export function setButtonDisabled(btn, disabled) {
  if (!btn) return;
  btn.disabled = !!disabled;
  if (disabled) {
    btn.setAttribute('aria-disabled', 'true');
  } else {
    btn.removeAttribute('aria-disabled');
  }
}
